<script lang="ts">
  import { ENTRANCE_FRAME } from "#lib/ui/recipes.ts";
  import CtaPair from "./CtaPair.svelte";

  let { title, body }: { title: string; body: string } = $props();
</script>

<section class="relative overflow-hidden py-28 md:py-40" data-testid="cta-band">
  <div class="field" aria-hidden="true"></div>
  <div class={[ENTRANCE_FRAME, "relative flex flex-col items-center gap-7 text-center"]}>
    <h2 class="title max-w-4xl font-semibold text-ink-1">{title}</h2>
    <p class="max-w-xl text-bar leading-7 text-ink-2">{body}</p>
    <CtaPair testId="cta" />
  </div>
</section>

<style>
  .title {
    font-size: clamp(2.25rem, 5vw, 4rem);
    line-height: 1;
    letter-spacing: -0.05em;
    text-wrap: balance;
  }

  .field {
    position: absolute;
    inset: 0;
    background-image:
      linear-gradient(to right, var(--edge) 1px, transparent 1px),
      linear-gradient(to bottom, var(--edge) 1px, transparent 1px);
    background-size: 3rem 3rem;
    background-position: center;
    mask-image: radial-gradient(ellipse 55% 60% at 50% 50%, #000 10%, transparent 75%);
    opacity: 0.7;
  }

  .field::after {
    content: "";
    position: absolute;
    inset: 0;
    background: radial-gradient(
      ellipse 40% 45% at 50% 50%,
      color-mix(in srgb, var(--series-1) 14%, transparent),
      transparent 70%
    );
  }
</style>
